<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmProduct"
      :title="'CADASTRO DE PRODUTO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="form-group row">
        <div class="col-md-4">
          <NxInput
            required
            error-behavior="value"
            name="codigo"
            type="text"
            label="Código:"
            placeholder="Digite o Código do Produto:"
            @update:value="handleInputUpdate('codigo', $event, false)"
            :value="data.codigo"
            v-model="data.codigo"
          ></NxInput>
        </div>
        <div class="col-md-8">
          <NxInput
            required
            error-behavior="value"
            name="produto"
            type="text"
            label="Produto:"
            placeholder="Digite o Nome do Produto:"
            @update:value="handleInputUpdate('nome', $event, false)"
            :value="data.nome"
            v-model="data.nome"
          ></NxInput>
        </div>
        <div class="col-md-4">
          <NxSelectTipoQuadro
            allSelected
            @update:value="handleSelectUpdate('tipoAcessoProduto', $event)"
            :value="data.tipoAcessoProduto"
          />
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import ProductModel from '@/shared/models/configurations/productmodel.js'

import { NxSelectTipoQuadro } from '@/components/nexum/components/custom-selects/index.js'

export default {
  name: 'ProductAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ProductModel
    }
  },
  components: {
    NxSelectTipoQuadro
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {},
    onEdit (obj) {
      loading.push()
      this.setObjInData(obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      ProductRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ProductRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.data[fieldName] = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If to clear single select and update both types
      if (selectedValue) {
        this.data[fieldName] = selectedValue
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      this.data[field] = null
    },
    setObjInData (obj) {
      this.data.id = obj.id
      this.data.codigo = obj.codigo
      this.data.nome = obj.nome
      this.data.tipoAcessoProduto = obj.tipoAcessoProduto
      this.data.inative = obj.inative
    }
  }
}
</script>

<style lang="scss">
.formulate-input-element.formulate-input-element--text {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/product/components/add/productadd.vue